import type { APIRequestBody, APIResponse } from './base-fetch';
import { get, post, remove } from './base-fetch';

export type McpOAuthGrant =
  APIResponse<'/api/v4/users/me/mcp-oauth/grants'>[number];

/**
 * Track B UI aliases — API keeps `oauthClientId` / `createdAt`.
 * Map in the connector card via `toMcpOAuthGrantViewModel`.
 */
export type McpOAuthGrantViewModel = McpOAuthGrant & {
  connectedAt: McpOAuthGrant['createdAt'];
  oauthClient: McpOAuthGrant['oauthClientId'];
};

export const toMcpOAuthGrantViewModel = (
  grant: McpOAuthGrant,
): McpOAuthGrantViewModel => ({
  ...grant,
  connectedAt: grant.createdAt,
  oauthClient: grant.oauthClientId,
});

export type CompleteMcpOAuthConnectPayload =
  APIRequestBody<'/api/v4/users/me/mcp-oauth/complete'>;

export type McpOAuthConnectResponse =
  APIResponse<'/api/v4/users/me/mcp-oauth/connect'>;

export const startMcpOAuthConnect = () =>
  post<McpOAuthConnectResponse>('/v4/users/me/mcp-oauth/connect');

export const completeMcpOAuthConnect = (data: CompleteMcpOAuthConnectPayload) =>
  post<McpOAuthGrant>('/v4/users/me/mcp-oauth/complete', data);

export const fetchMcpOAuthGrants = () =>
  get<McpOAuthGrant[]>('/v4/users/me/mcp-oauth/grants');

export const revokeMcpOAuthGrant = (id: string) =>
  remove<void>(`/v4/users/me/mcp-oauth/grants/${id}`);
